import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const TimerWhiteIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon width={72} height={72} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M54 66L53.97 48L42 36L53.97 23.97L54 6H18V24L30 36L18 47.97V66H54ZM24 22.5V12H48V22.5L36 34.5L24 22.5Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default TimerWhiteIcon;
